import {CONSONANT_VOWEL_PAIRS_CH_T} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_cht";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_CH_T_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_CH_T} title="Consonant-Vowel Pairs: ㅊ (ch/t)" />
     </>
);}